export enum CompanyCarType {
  COMPANY_CAR = 'COMPANY_CAR',
  CAR_ALLOWANCE = 'CAR_ALLOWANCE',
  COMPANY_CAR_CAR_ALLOWANCE = 'COMPANY_CAR_CAR_ALLOWANCE',
}

export const getCompanyCarType = (type: string | null | undefined): CompanyCarType => {
  if (type === 'CAR_ALLOWANCE') {
    return CompanyCarType.CAR_ALLOWANCE
  } else if (type === 'COMPANY_CAR_CAR_ALLOWANCE') {
    return CompanyCarType.COMPANY_CAR_CAR_ALLOWANCE
  } else {
    return CompanyCarType.COMPANY_CAR
  }
}
